"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTypeToJSON = exports.FieldTypeFromJSONTyped = exports.FieldTypeFromJSON = exports.FieldType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var FieldType;
(function (FieldType) {
    FieldType["STRING"] = "STRING";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["BOOLEAN"] = "BOOLEAN";
    FieldType["OPTIONS"] = "OPTIONS";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
function FieldTypeFromJSON(json) {
    return FieldTypeFromJSONTyped(json, false);
}
exports.FieldTypeFromJSON = FieldTypeFromJSON;
function FieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.FieldTypeFromJSONTyped = FieldTypeFromJSONTyped;
function FieldTypeToJSON(value) {
    return value;
}
exports.FieldTypeToJSON = FieldTypeToJSON;
